import { CATEGORY_TOGGLE } from 'Config/types';
import { push } from 'Actions/router';
import utils from 'Utils';

const { curry } = utils.fpHelpers;

/**
 * This middleware adjusts selected indicators if categories change
 */
export const categoryIndicatorMiddleware = (
  { getState, dispatch },
  next,
  action
) => {
  if (action.type !== CATEGORY_TOGGLE) {
    return next(action);
  }
  const state = getState();
  const { category } = action.payload;

  const indicators = state.data
    .categories[category]
    .indicators
    .reduce((acc, x) => (
      Object.hasOwnProperty.call(state.data.indicators[x], 'children') ?
        acc.concat(state.data.indicators[x].children) :
        acc.concat(x)
    ),
    [])
    .map((x) => `${x}`);

  if (state.router.indicators) {
    const batch = state.router.indicators
      .filter((x) => -1 < indicators.indexOf(x))
      .map((x) => ({ indicators: x }));

    dispatch(push({ batch }));
  }

  return next(action);
};

export default curry(categoryIndicatorMiddleware);



// WEBPACK FOOTER //
// ./app/middleware/categoryIndicator.js